import el from "@cypherpotato/el";
import { formatNumber } from "../ui/format";
import { getUniqueColor } from "../ui/unique-color";
import { pipe } from "../util";

export function SegmentBar({ segments, autosize, compact = false }) {

    const total = segments.reduce((a, b) => a + b.value, 0);

    return el("div.segment-bar",
        ...segments.filter(s => s.value > 0).map(segment => pipe(segment.value / total * 100, percentage =>
            el(".segment-bar-segment",
                percentage > 10 && el("label", segment.label, el("strong", formatNumber(segment.value))),
                el("div", {
                    style: {
                        backgroundColor: segment.color || getUniqueColor(segment.label),
                        color: segment.color || getUniqueColor(segment.label),
                    }
                }),
                {
                    dataItemPercentage: percentage,
                    title: `${segment.label} (${Math.round(percentage)}%)`,
                    style: {
                        width: autosize ? percentage + "%" : segment.value + "%",
                        display: compact && percentage <= 10 && "none" || null
                    }
                }
            )
        ))
    );
}